module.exports = __webpack_public_path__ + "img/up.f1c168da.png";